/**
 * Breakpoints del planner 3D (capa de presentación).
 * Fuente de verdad para layout responsive — no usar ad-hoc en paneles de negocio.
 *
 * Desktop   > 1280
 * Tablet H  1024–1280
 * Tablet V  768–1024
 * Mobile    < 768
 *
 * Correspondencia: ATEMPORAL mobile-28-07-2026 (`47ee2081`).
 */
export const VIEWPORT_BREAKPOINTS = {
  mobileMax: 767,
  tabletVMin: 768,
  tabletVMax: 1023,
  tabletHMin: 1024,
  tabletHMax: 1279,
  desktopMin: 1280,
} as const

export type ViewportLayout = 'mobile' | 'tabletV' | 'tabletH' | 'desktop'

export const VIEWPORT_LAYOUTS = ['mobile', 'tabletV', 'tabletH', 'desktop'] as const

export function getViewportLayout(width: number): ViewportLayout {
  if (width <= VIEWPORT_BREAKPOINTS.mobileMax) return 'mobile'
  if (width <= VIEWPORT_BREAKPOINTS.tabletVMax) return 'tabletV'
  if (width <= VIEWPORT_BREAKPOINTS.tabletHMax) return 'tabletH'
  return 'desktop'
}

/** Media queries alineadas con getViewportLayout (matchMedia). */
export const VIEWPORT_MEDIA_QUERIES = {
  mobile: `(max-width: ${VIEWPORT_BREAKPOINTS.mobileMax}px)`,
  tabletV: `(min-width: ${VIEWPORT_BREAKPOINTS.tabletVMin}px) and (max-width: ${VIEWPORT_BREAKPOINTS.tabletVMax}px)`,
  tabletH: `(min-width: ${VIEWPORT_BREAKPOINTS.tabletHMin}px) and (max-width: ${VIEWPORT_BREAKPOINTS.tabletHMax}px)`,
  desktop: `(min-width: ${VIEWPORT_BREAKPOINTS.desktopMin}px)`,
} as const

export function isTouchLayout(layout: ViewportLayout): boolean {
  return layout === 'mobile' || layout === 'tabletV'
}

export function isCompactLayout(layout: ViewportLayout): boolean {
  return layout !== 'desktop'
}
